module.exports = __webpack_public_path__ + "img/home_gym.5140e0a1.jpg";